import { ab } from './interface'
import { Experiment } from './types'

/**
 * Initialize CloudFront experiments.
 *
 * Check A/B testing cookies set by CloudFront, send backend
 * requests and update frontend a/b data storage.
 */
export async function initAB(): Promise<void> {
  // Unused, example:
  // await sitePage1208Experiment()
  // await summaryPage1252Experiment()
  // await summaryPageDesign1505Experiment()
}
/**
 * Feature flag to enable/disable Google Billing. Disabled by default.
 *
 * This is not a real A/B experiment, i.e. the experiment is not activated on
 * the backend.
 */
export function googleBillingEnabled(): boolean {
  return ab.experimentVariant(Experiment.google_billing_7517) === 'yes'
}

/**
 * Make 'View all' buttons more prominent
 */
export async function viewAllButton9162Experiment(): Promise<'A' | 'B' | 'C'> {
  let result = ab.experimentVariant(Experiment.view_all_button_9162)

  if (result === null) {
    result = await ab.start(Experiment.view_all_button_9162)
  }

  return (result || 'A') as 'A' | 'B' | 'C'
}

/**
 * Get the current `view_all_button_9162` experiment variant
 */
export function viewAllButton9162ExperimentVariant(): 'A' | 'B' | 'C' {
  const result = ab.experimentVariant(Experiment.view_all_button_9162)
  return (result || 'A') as 'A' | 'B' | 'C'
}

/**
 * Show (or don't show) the Podcasts item in the navigation and the block on search page
 * Returns boolean:
 *   true/excluded - show the podcast item in the header and the data on the search page
 *   false - don't the item in the header and the data on the search page
 */
export async function podcasts12992Experiment(): Promise<boolean> {
  let result = ab.experimentVariant(Experiment.podcasts_12992)

  if (result === null) {
    result = await ab.start(Experiment.podcasts_12992)
  }

  return result === 'yes'
}

/**
 * Show (or don't show) the Podcasts item in the navigation and the block on search page
 * Returns boolean:
 *   true/excluded - show the podcast item in the header and the data on the search page
 *   false - don't the item in the header and the data on the search page
 */
export function podcasts12992ExperimentVariant(): boolean {
  const result = ab.experimentVariant(Experiment.podcasts_12992)
  return result === 'yes' || result === '_EXCLUDED_'
}

/**
 * Make the annual plan in the billing page more prominent
 */
export async function discountProminencePopularFlag12463Experiment(): Promise<
  'A' | 'B' | 'C'
> {
  let result = ab.experimentVariant(
    Experiment.discount_prominence_popular_flag_12463,
  )

  if (result === null) {
    result = await ab.start(Experiment.discount_prominence_popular_flag_12463)
  }

  return (result || 'A') as 'A' | 'B' | 'C'
}

/**
 * Get the current `discount_prominence_popular_flag_12463` experiment variant.
 *
 * @returns {"A" | "B" | "C"} Description of return values:
 *   - A: Control (no changes)
 *   - B: Make the annual plan discount more
 *   - C: Display "Most Popular" flag
 */
export function discountProminencePopularFlag12463Variant(): 'A' | 'B' | 'C' {
  const result = ab.experimentVariant(
    Experiment.discount_prominence_popular_flag_12463,
  )
  return (result || 'A') as 'A' | 'B' | 'C'
}

/**
 * Get the variant of the LibraryV1_1 experiment.
 * Returns boolean:
 *   true - Show the LibraryV1_1.vue component
 *   false - Show the Library.vue component
 */
export function libraryV1_1Experiment12817Variant(): boolean {
  return ab.experimentVariant(Experiment.library_v1_1_12817) === 'yes'
}

/**
 * Decide which component to render on the /app/library page.
 * Returns boolean:
 *   true - Show the LibraryV1_1.vue component
 *   false - Show the Library.vue component
 */
export async function libraryV1_1Experiment12817(): Promise<boolean> {
  let result = ab.experimentVariant(Experiment.library_v1_1_12817)

  if (result === null) {
    result = await ab.start(Experiment.library_v1_1_12817)
  }

  return result === 'yes'
}
